export const siteConfig = {
  name: '韩漫网',
  tagline: '韩漫大全 · 好看的韩国漫画 · 免费在线观看',
  description: '在韩漫网探索精选韩漫大全与好看韩国漫画，所有内容免费在线观看，界面简洁操作方便，即刻开启您的视觉盛宴。',
  url: 'https://hanman.example.com',
  logo: '韩漫网',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '分类', href: '/category/all' },
  { label: '关于我们', href: '/about' },
];

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-flashlight-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-movie-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line' },
  { slug: 'school', name: '校园', icon: 'ri-book-open-line' },
  { slug: 'historical', name: '古风', icon: 'ri-ancient-gate-line' },
];

export const footerLinks = {
  navigation: [
    { label: '首页', href: '/' },
    { label: '全部分类', href: '/category/all' },
    { label: '恋爱漫画', href: '/category/romance' },
    { label: '奇幻漫画', href: '/category/fantasy' },
    { label: '动作漫画', href: '/category/action' },
  ],
  support: [
    { label: '关于我们', href: '/about' },
    { label: '联系我们', href: '/about#contact' },
    { label: '版权声明', href: '/about#copyright' },
    { label: '隐私政策', href: '/about#privacy' },
  ],
};